<template>
  <v-card>
    <v-card-text>
      <datasource-table ref="dataTable" :datasource="datasource">
        <template #item.dateCreation="{ item }">
          {{ formatDate(item.dateCreation) }}
        </template>
        <template #item.download="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-on:click="selectedItemTraitements(item)"
                >mdi-eye-circle</v-icon
              >
            </template>
            <span>{{ $t('fiche.list.eyeHover') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-on:click="selectedItemTraitements(item, true)"
                >mdi-download-circle</v-icon
              >
            </template>
            <span>{{ $t('fiche.list.downloadHover') }}</span>
          </v-tooltip>
        </template>
      </datasource-table>
    </v-card-text>
    <v-dialog v-model="visualisePDF" scrollable max-width="100%">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ currentDocument.fileName }}
          <v-spacer></v-spacer>
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-title>

        <v-card-text style="height: 600em">
          <vue-pdf-app
            :pdf="currentDocument.contentDocument"
            :file-name="currentDocument.fileName"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource'
import moment from 'moment'
import Api from '@/utils/api'
import toasted from '@/utils/toasted'
import VuePdfApp from 'vue-pdf-app'
import { getter } from '@/utils/store'
// import this to use default icons for buttons
import 'vue-pdf-app/dist/icons/main.css'
import _ from 'lodash'

export default {
  components: {
    VuePdfApp,
  },
  beforeCreate() {
    let idTechnique = getter('oauth/idTechnique')
    new Api('mail')
      .get()
      .then((response) => {
        if (!response.bodyText) {
          toasted.error('document.error.mail')
        }
        this.mail = response.bodyText
      })
      .catch((error) => {
        try {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.mail')
          }
        } catch (err) {
          console.log('')
        }
      })
  },
  data() {
    const fields = [
      {
        value: 'dateCreation',
        sortable: true,
      },
      {
        value: 'nomDocument',
        sortable: true,
      },
      {
        value: 'download',
        text: this.$t('accueil.documents.headers.download'),
        particular: true,
        sortable: false,
      },
    ]
    const datasource = new Datasource('fiche/list', {
      page: 1,
      rowsPerPage: 20,
      descending: true,
      labelNamespace: 'fiche.list',
      noDataText: this.$t('fiche.list.noDataText'),
      args: {
        actif: true,
      },
      fields,
    })
    return {
      expanded: [],
      enums: {
        typeDocument: [],
        dates: [],
      },
      bilans: [],
      mail: null,
      datasource,
      documentsSelected: [],
      visualisePDF: false,
      dialogSendDocuments: false,
      currentDocument: {
        contentDocument: null,
        fileName: null,
      },
      headers: fields,
      showPassword: false,
      envoiDocs: false,
    }
  },
  mounted() {
    this.datasource.refresh()
  },
  computed: {
    iconBilan() {
      if (this.choiceAllBilans) return 'mdi-close-box'
      if (this.choiceSomeBilans) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    iconTypeDocument() {
      if (this.choiceAllTypesDocuments) return 'mdi-close-box'
      if (this.choiceSomeTypesDocuments) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    selectedItemTraitements(item, download) {
      this.$api(`document/${item.id}/ls`)
        .get()
        .then((response) => {
          if (download) {
            this.downloadPDF(response.body)
          } else {
            this.previewPDF(response.body)
          }
        })
        .catch((error) => {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.selectdocument')
          }
        })
    },

    extractDocument(document) {
      const binaryString = window.atob(document.bytes) // Comment this if not using base64
      const bytes = new Uint8Array(binaryString.length)
      return bytes.map((byte, i) => binaryString.charCodeAt(i))
    },

    previewPDF(document) {
      if (document) {
        const mappedData = this.extractDocument(document)
        this.currentDocument.contentDocument = mappedData.buffer
        this.currentDocument.fileName = document.document.nomDocument
        this.visualisePDF = true
      }
    },

    downloadPDF(doc) {
      if (doc) {
        const mappedData = this.extractDocument(doc)
        var blob = new Blob([mappedData], { type: 'application/pdf' })
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.href = url
        link.setAttribute('download', doc.document.nomDocument) // Nom du fichier de téléchargement
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
  },
}
</script>

<style scoped>
.layout {
  align-items: center;
}
.flex {
  padding: 5px;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
  text-align: end;
}
.v-toolbar {
  max-height: 44px;
}
.v-label {
  margin-right: 10px;
}
.v-toolbar__title {
  font-size: 18px;
  margin-bottom: 15px;
}
</style>
<style>
.v-data-table__wrapper .v-simple-checkbox--disabled {
  display: none;
}

.custom-select .v-input__icon.v-input__icon--append .v-icon {
  font-size: 48px;
}

.custom-select .v-input__append-inner {
  display: flex;
  height: 100%;
  align-items: center;
}

.v-menu__content {
  max-height: 550px !important;
}
</style>
